import {
  HIDE_CAMPAIGN_OFFER_TYPES_LOADER,
  SET_CAMPAIGN_OFFER_TYPE_PROFILE,
  SET_CAMPAIGN_OFFER_TYPES_LIST,
  SET_ERROR_CAMPAIGN_OFFER_TYPE_PROFILE,
  SHOW_CAMPAIGN_OFFER_TYPES_LOADER
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: []
  },
  profileData: [],
  isError: false,
  loading: false,
  // success: null,
  error: null
}

const CampaignOfferTypeList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_OFFER_TYPES_LIST:
      return {
        ...state,
        data: action.payload
      }
    case SHOW_CAMPAIGN_OFFER_TYPES_LOADER:
      return {
        ...state,
        loading: true
      }
    case HIDE_CAMPAIGN_OFFER_TYPES_LOADER:
      return {
        ...state,
        loading: false
      }
    case SET_CAMPAIGN_OFFER_TYPE_PROFILE:
      return {
        ...state,
        profileData: action.payload
      }
    case SET_ERROR_CAMPAIGN_OFFER_TYPE_PROFILE:
      return {
        ...state,
        isError: action.payload
      }
    default:
      return state
  }
}

export default CampaignOfferTypeList;
